import React from "react";

const SignupPageLayout = ({ formSectionContent, featuresSectionContent }) => {
    return (
        <div
            id="signup"
            className="container row signup-form-container signup-page-layout"
        >
            <section className="signup-styles padded-column columns five">
                {formSectionContent}
            </section>
            <section className="columns five offset-two">
                {featuresSectionContent}
            </section>
        </div>
    );
};

export default SignupPageLayout;
